export default __webpack_public_path__ + "static/Advanced_Rifle_Bullet-9d16e0301e40809f9350ad3298d0a47d.png";